import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import ShieldText from './ShieldText';
import {
  getCurrentWeight,
  getFitnessProgram,
  postCurrentWeight,
  postVideoLogTime,
  postCurrentBP,
  postCurrentBS,
  postCurrentHbA1c,
} from '../../services';
import Modal from '../common/Modal';
import Player from './FitnessPlayer';
import { FlyInTransition } from '../../components/transitions/transitions';
import ScalePicker from './ScalePicker';
import LoadingComponent from '../../components/common/LoadingComponent';
import BloodPressureCard from '../../components/health-content/BloodPressureCard';
import WeightCard from '../../components/health-content/WeightCard';

import WeightIcon from '../../images/health-content/weight-icon.svg';
import GlassIcon from '../../images/health-content/glass-icon.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import closeIcon from '../../images/health-content/close-modal.svg';
import MealIcon from '../../images/health-content/meal-icon.svg';
import warningIcon from '../../images/health-content/warning-icon.svg';
import AddIcon from '../../images/health-content/add-icon.svg';
import BloodPressureIcon from '../../images/health-content/blood-pressure-icon.svg';
import BloodSugarIcon from '../../images/health-content/blood-sugar-icon.svg';
import HbA1cIcon from '../../images/health-content/hbA1c-icon.svg';
import BloodSugarCard from '../../components/health-content/BloodSugarCard';
import WaterCard from '../../components/health-content/WaterCard';
import Hba1cCard from '../../components/health-content/Hba1cCard';
import { FaPlay } from 'react-icons/fa';
import SleepCard from '../../components/health-content/SleepCard';
import StepsCard from '../../components/health-content/StepsCard';
import CalorieCardImg from '../../images/health-content/TotalCalorieBurnt.svg';
import rightArrow from '../../images/common/arrow-right-black.svg';
import CalorieGraph from '../../components/trackers/CalorieGraph';

const OuterContainer = styled.div`
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;

const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const Card = styled.button`
  border: 1px solid #e3e3e3;
  border-radius: 0.5rem;
  text-align: left;
  width: 100%;
`;

const Button = styled.button`
  width: 100%;
  background-color: #f0f3f6;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  cursor: pointer;
`;

const WeightModalContainer = styled.div`
  display: flex;
  height: 500px;
  width: 440px;
  flex-direction: column;
  background: rgba(255, 255, 255);
  overflow: hidden;
  cursor: pointer;
  border-radius: 12px 12px 0 0;
`;

const BPInputBox = styled.input`
  width: 70%;
  border-bottom: 1px solid black;
  font-size: 48px;
  font-weight: 700;
  color: #01040d;
  text-align: center;
  ::placeholder {
    text-align: center;
    font-size: 48px;
    font-weight: 500;
  }
`;

const BloodSugarInputBox = styled.input`
  width: 60%;
  border-bottom: 1px solid black;
  font-size: 48px;
  font-weight: 700;
  color: #01040d;
  text-align: center;
  ::placeholder {
    text-align: center;
    font-size: 48px;
    font-weight: 500;
  }
`;

const BloodSugarLabel = styled.div`
  padding: 12px 16px;
  border-radius: 12px;
  background: ${(props) =>
    props.value === props.logTime ? 'var(--primary-button)' : '#F0F3F6'};
  color: ${(props) => (props.value === props.logTime ? '#FFFFFF' : '#767787')};
  cursor: pointer;
`;

function VideoCard({
  sessionImg,
  sessionTitle,
  sessionUrl,
  completionRatio,
  sessionId,
  getData,
}) {
  const history = useHistory();

  function navigateToMyWeeklyPlan() {
    history.push('weekly-plan');
  }
  const { authToken } = useSelector((state) => state.user);

  function VideoLesson() {
    const [showPlayerModal, setShowPlayerModal] = useState(false);

    const hideModal = () => {
      setShowPlayerModal(false);
      getData();
    };

    const logTime = async (duration, position) => {
      try {
        await postVideoLogTime(authToken, {
          duration: position,
          sessionId,
          timestamp: +new Date(),
          actualWatchDuration: Math.ceil((position / duration) * 10),
        });
      } catch (error) {
        console.error('Error logging video time:', error);
      }
    };

    return (
      <div
        style={{
          backgroundImage: `url(${sessionImg})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
        className="rounded-lg bg-center bg-imageBg py-2 h-36 w-100 relative"
      >
        <div className="w-100 absolute bottom-0 rounded-b-lg flex flex-col justify-between bg-opacity50">
          <ProgressBar
            barColor="white"
            current={completionRatio}
            total={1}
            height={1}
            rounded="0"
            bgColor="rgba(0, 0, 0, 0.7)"
          />
          <div className="w-full px-4 py-1 flex justify-between">
            <h2 className="text-txtlight text-title-s font-bold mt-1">
              {sessionTitle}
            </h2>
            {sessionUrl ? (
              <button
                onClick={() => setShowPlayerModal(true)}
                className="bg-textbox px-6 py-2 rounded-full text-body-s font-semibold flex items-center gap-4px"
              >
                <span> Continue </span>
                <span>
                  {' '}
                  <FaPlay size={10} color="black" />
                </span>
              </button>
            ) : (
              <button
                onClick={navigateToMyWeeklyPlan}
                className="bg-textbox px-6 py-2 rounded-full text-body-s font-semibold"
              >
                My Weekly Plan &gt;
              </button>
            )}
          </div>
        </div>
        {showPlayerModal && (
          <Modal>
            <ModalContainer onClick={hideModal}>
              <FlyInTransition
                in={showPlayerModal}
                mountOnEnter
                unmountOnExit
                appear
              >
                <Player
                  authToken={authToken}
                  hideModal={hideModal}
                  url={sessionUrl}
                  logTime={logTime}
                />
              </FlyInTransition>
            </ModalContainer>
          </Modal>
        )}
      </div>
    );
  }

  return (
    <div className="p-7 border-b-4 border-txtlight-shades4">
      <div className="flex justify-between mb-10">
        <h1 className="text-caption-l font-semibold uppercase">
          Today's Workout
        </h1>
        <button
          className="text-caption-l font-semibold"
          onClick={navigateToMyWeeklyPlan}
        >
          My weekly plan&nbsp;
          <span
            className="bg-txtlight-shades4 px-2 rounded-full inline-block"
            style={{ transform: 'scale(.5, .8)' }}
          >
            &gt;
          </span>
        </button>
      </div>
      <VideoLesson />
    </div>
  );
}

function ProgressBar({
  total,
  current,
  barColor = '#1EB865',
  className = '',
  height = 1,
  rounded = 'full',
  bgColor = 'txtlight-shades4',
}) {
  return (
    <div
      className={`${className} w-100 bg-${bgColor} h-${height} rounded-${rounded}`}
    >
      <div
        className={`h-full rounded-${rounded}`}
        style={{
          width: `${(current / total) * 100}%`,
          backgroundColor: barColor,
        }}
      ></div>
    </div>
  );
}

function TaskCards({
  weightCard,
  loading,
  waterCard,
  nutritionCard,
  bpCard,
  bsCard,
  hbA1cCard,
  getData,
  setModalState,
  sleepCard,
  stepCard,
  calorieCard,
}) {
  const { authToken } = useSelector((state) => state.user);
  const history = useHistory();

  function MicroNutrientTracker({
    current,
    target,
    name = 'untitled',
    barColor = '',
  }) {
    return (
      <div className="w-half p-1 m-1">
        <h2 className="capitalize text-body-s font-bold">
          {current}g <span className="text-sub font-medium">{name}</span>
        </h2>
        <h4 className="capitalize text-sub text-chip mb-2">{target}g goal</h4>
        <ProgressBar
          height={1}
          barColor={barColor}
          current={current}
          total={target}
        />
      </div>
    );
  }

  return (
    <div className="p-4">
      <div>
        {!loading && (
          <>
            <h1 className="text-body-s font-semibold uppercase">Your Tasks</h1>
            {calorieCard && (
              <Card className="mt-15">
                <div className="flex items-center justify-between p-16px">
                  <div className="flex items-center gap-4px">
                    <img src={CalorieCardImg} alt="calorie-icon" />
                    <div className="font-semibold text-body-s">
                      Total Calorie Burnt
                    </div>
                  </div>
                  <img src={rightArrow} alt="right-arrow" />
                </div>
                <div className="p-16px flex items-center justify-between">
                  <div className="whitespace-nowrap">
                    <div>
                      <span className="font-bold text-title-xl">
                        {calorieCard?.current}{' '}
                      </span>
                      <span className="text-txtsecondary text-body-s font-medium">
                        {' '}
                        {calorieCard?.unit}
                      </span>
                    </div>
                    <div className="font-medium text-body-s text-txtsecondary">
                      of {calorieCard?.goal} {calorieCard?.unit}
                    </div>
                  </div>{' '}
                  <CalorieGraph calorieCard={calorieCard} />
                </div>

                <div className="border-t border-txtsecondary-shades4"></div>
                <div
                  className="flex items-center justify-between bg-accent2-shades2 py-12px px-16px"
                  style={{
                    borderRadius: '0px 0px 12px 12px',
                  }}
                >
                  <div className="flex items-center">
                    <div className="text-txtsecondary font-medium text-body-s">
                      Current:{' '}
                    </div>
                    <div className="text-icon text-body-s font-semibold">
                      &nbsp; {calorieCard?.streak?.current}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="text-txtsecondary font-medium text-body-s">
                      Best:{' '}
                    </div>
                    <div className="text-icon text-body-s font-semibold">
                      &nbsp; {calorieCard?.streak?.best}
                    </div>
                  </div>
                </div>
              </Card>
            )}
            <div className="grid grid-cols-2 gap-x-3 gap-y-2">
              {weightCard && (
                <WeightCard weightCard={weightCard} getData={getData} />
              )}
              {bpCard && (
                <BloodPressureCard bpCard={bpCard} getData={getData} />
              )}
              {/* <BloodSugarCard /> */}
              {hbA1cCard && (
                <Hba1cCard getData={getData} hbA1cCard={hbA1cCard} />
              )}
              {waterCard && (
                <WaterCard getData={getData} waterCard={waterCard} />
              )}
              {sleepCard && <SleepCard sleepCard={sleepCard} />}
              {stepCard && <StepsCard stepCard={stepCard} />}
            </div>

            {nutritionCard && (
              <Card onClick={() => history.push('/logmeal')} className="mt-15">
                <div className="p-15 border-bottom">
                  <div className="flex justify-between">
                    <img src={MealIcon} alt="knife-fork-icon" />
                    <h1 className="text-title-l font-bolder px-2 pr-0 mt-0.5">
                      {nutritionCard.current}{' '}
                      <span className="text-title-l font-semibold">Cal</span>
                    </h1>
                  </div>
                  <div className="flex justify-between">
                    <h6 className="text-body-s font-semibold mt-1">Meal Log</h6>
                    <h4 className="px-2 pr-0 text-title-s text-sub font-medium">
                      Goal&nbsp;
                      <span className="font-semibold text-custom1eb865">
                        {nutritionCard.goal} Cal
                      </span>
                    </h4>
                  </div>
                  <ProgressBar
                    current={nutritionCard.current}
                    total={nutritionCard.goal}
                    className="mt-10"
                    height={2}
                  />
                </div>
                <div className="p-15 border-bottom flex justify-between">
                  <MicroNutrientTracker
                    current={nutritionCard.progress.carbs}
                    target={nutritionCard.progress.carbsGoal}
                    name="carbs"
                    barColor="#FF7268"
                  />
                  <MicroNutrientTracker
                    name="protein"
                    current={nutritionCard.progress.protein}
                    target={nutritionCard.progress.proteinGoal}
                    barColor="#244CB2"
                  />
                  <MicroNutrientTracker
                    name="fat"
                    current={nutritionCard.progress.fat}
                    target={nutritionCard.progress.fatGoal}
                    barColor="#FFA800"
                  />
                </div>
                <div className="p-15 border-bottom">
                  {nutritionCard.logs.map((log) => {
                    const getTotalCalories = () => {
                      let total = 0;
                      log.meals.forEach((meal) => {
                        total += meal.calorie;
                      });
                      return total;
                    };
                    const getTotalCarbs = () => {
                      let total = 0;
                      log.meals.forEach((meal) => {
                        total += meal.carbs;
                      });
                      return total;
                    };
                    const getTotalProtein = () => {
                      let total = 0;
                      log.meals.forEach((meal) => {
                        total += meal.protein;
                      });
                      return total;
                    };
                    const getTotalFat = () => {
                      let total = 0;
                      log.meals.forEach((meal) => {
                        total += meal.fat;
                      });
                      return total;
                    };
                    let unit = 'g';

                    return (
                      <div className="bg-primary-light rounded-lg p-15 mb-10px">
                        <div className="flex justify-between text-body-l mb-5">
                          <h2 className="font-semibold">{log.mealType}</h2>
                          <h2 className="font-bold text-">
                            {getTotalCalories()}
                            <span className="text-sub font-regular"> Cal</span>
                          </h2>
                        </div>
                        <div className="flex w-full">
                          {log.meals.map((meal, i) => {
                            unit = unit !== 'kg' ? meal.unit : unit;
                            return (
                              <p className="text-body-s text-sub mb-2">
                                {meal.mealName} x{meal.quantity}
                                {i + 1 !== log.meals.length && (
                                  <span>,</span>
                                )}{' '}
                              </p>
                            );
                          })}
                        </div>
                        <p className="text-body-s text-sub">
                          <span className="inline-block h-1 w-3 rounded mb-0.5 ml-0 mr-1 bg-customFF7268 "></span>
                          {getTotalCarbs()}
                          {unit}
                          <span className="inline-block h-1 w-3 rounded mb-0.5 ml-10 mr-1 bg-secondary-shades3"></span>
                          {getTotalProtein()}
                          {unit}
                          <span className="inline-block h-1 w-3 rounded mb-0.5 ml-10 mr-1 bg-customFFA800"></span>
                          {getTotalFat()}
                          {unit}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div className="p-15">
                  <Button>
                    <img src={AddIcon} alt=""></img>{' '}
                    <span className="ml-8px">Log Meal</span>
                  </Button>
                </div>
              </Card>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function MyFitness({ onboarded }) {
  const history = useHistory();
  const { authToken } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(true);
  const [weightCard, setWeightCard] = useState(null);
  const [waterCard, setWaterCard] = useState(null);
  const [nutritionCard, setNutritionCard] = useState(null);
  const [bpCard, setBpCard] = useState(null);
  const [bsCard, setBsCard] = useState(null);
  const [hbA1cCard, setHbA1cCard] = useState(null);
  const [sleepCard, setSleepCard] = useState(null);
  const [stepCard, setStepCard] = useState(null);
  const [calorieCard, setCalorieCard] = useState(null);

  const [videoCard, setVideoCard] = useState(null);

  const [modalState, setModalState] = useState('open');

  const getProgram = async () => {
    try {
      const data = await getFitnessProgram(authToken);
      data.tasks.forEach((task) => {
        if (task.type === 'weight') setWeightCard(task);
        if (task.type === 'water') setWaterCard(task);
        if (task.type === 'nutrition') setNutritionCard(task);
        if (task.type === 'sleep') setSleepCard(task);
        if (task.type === 'steps') setStepCard(task);
        if (task.type === 'calories') setCalorieCard(task);
      });
      setVideoCard(data.nextWorkout);
      const cardData = await getCurrentWeight(authToken);
      cardData.healthData.forEach((task) => {
        if (task.name === 'BP') setBpCard(task);
        if (task.name === 'BS') setBsCard(task);
        if (task.name === 'HB') setHbA1cCard(task);
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching fitness program:', error);
    }
  };

  useEffect(() => {
    if (!onboarded) getProgram();
  }, [modalState]);

  function navigateToOnboarding() {
    history.push('my-fitness-onboarding');
  }

  if (onboarded) {
    return (
      <OuterContainer className="p-15">
        <InnerContainer className="flex flex-col justify-center items-center">
          <h1 className="font-bold text-title-xl text-center">
            You haven't created your <br /> program yet.
          </h1>
          <div className="text-sub text-body-l text-center mt-20 w-full">
            <p>🏓 Get Daily Recommendations</p>
            <p className="mt-5"> 📈 Track your progress</p>
            <p className="mt-5">💯 Achieve your health targets</p>
            <p className="mt-5">
              🎯 Get rewarded for maintaining weekly streaks
            </p>
          </div>
          <button
            onClick={navigateToOnboarding}
            className="mt-14 w-4/5 bg-primary-button py-4 rounded-12 font-semibold font-body-l text-txtlight text-body-l"
          >
            Create your program
          </button>

          <ShieldText />
        </InnerContainer>
      </OuterContainer>
    );
  }

  return (
    <OuterContainer className="">
      {!loading ? (
        <>
          <VideoCard getData={getProgram} {...videoCard} />
          <TaskCards
            loading={loading}
            weightCard={weightCard}
            waterCard={waterCard}
            nutritionCard={nutritionCard}
            bpCard={bpCard}
            bsCard={bsCard}
            hbA1cCard={hbA1cCard}
            getData={getProgram}
            setModalState={setModalState}
            sleepCard={sleepCard}
            stepCard={stepCard}
            calorieCard={calorieCard}
          />
        </>
      ) : (
        <LoadingComponent />
      )}
    </OuterContainer>
  );
}

const ErrorText = () => {
  return (
    <div className="flex mt-8px">
      <img src={warningIcon} alt="" />
      <p className="text-body-s ml-4px text-accent2-shades4">
        Please enter a valid value
      </p>
    </div>
  );
};
